import React from 'react';
import { colors } from './constants';

const WardStats = ({ stats, currentCategory }) => {
  const styles = {
    wardInfo: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
      gap: '16px',
      marginBottom: '32px'
    },
    wardStat: {
      background: colors.cream100,
      border: `1px solid rgba(94, 82, 64, 0.12)`,
      borderRadius: '8px',
      padding: '16px',
      textAlign: 'center'
    },
    wardStatLabel: {
      fontSize: '12px',
      color: colors.slate500,
      marginBottom: '8px'
    },
    wardStatValue: {
      fontSize: '24px',
      fontWeight: 550,
      color: colors.slate900
    }
  };

  return (
    <div style={styles.wardInfo}>
      <div style={styles.wardStat}>
        <div style={styles.wardStatLabel}>Total Beds</div>
        <div style={styles.wardStatValue}>{stats.total}</div>
      </div>
      <div style={styles.wardStat}>
        <div style={styles.wardStatLabel}>Available</div>
        <div style={{ ...styles.wardStatValue, color: colors.teal500 }}>
          {stats.available}
        </div>
      </div>
      <div style={styles.wardStat}>
        <div style={styles.wardStatLabel}>Occupied</div>
        <div style={{ ...styles.wardStatValue, color: colors.red500 }}>
          {stats.occupied}
        </div>
      </div>
      <div style={styles.wardStat}>
        <div style={styles.wardStatLabel}>Reserved</div>
        <div style={{ ...styles.wardStatValue, color: colors.orange500 }}>
          {stats.reserved}
        </div>
      </div>
      <div style={styles.wardStat}>
        <div style={styles.wardStatLabel}>Occupancy Rate</div>
        <div style={styles.wardStatValue}>{stats.occupancyRate}%</div>
      </div>
      <div style={{ 
        background: colors.teal500, 
        color: colors.cream50, 
        borderRadius: '8px', 
        padding: '16px', 
        fontSize: '16px', 
        fontWeight: 500, 
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        {currentCategory?.category}
      </div>
    </div>
  );
};

export default WardStats;
